(ns ncr.backend
  (:require
   [clojure.core.match :refer [match]]
   [clojure.string :as str]
   [cljs.core.async :as async :refer-macros [go]]
   [cljs-http.client :as http]
   [taoensso.encore :as e]
   [com.rpl.specter :as sp]
   [tick.core :as t]
   [lambdaisland.glogi :as log]
   [graphql-query.core :as gql]
   [ncr.etc.util :as u]
   [ncr.etc.modal :as m]
   [ncr.etc.pubsub :as ps]
   [ncr.auth :as a]
   [ncr.etc.pf :as pf]
   [goog.string :as gstr]
   [ncr.backend-http :as bh]))

(def cluster-slug
  (atom nil))

(defn !request [query variables headers]
  (go
    (let [token (<! (a/token))]
      (let [location "/api/graphql"]
        (let
          [response
           (<!
             (bh/post location
               {:with-credentials? true
                :oauth-token token
                :headers
                (merge headers
                  (when (some? @cluster-slug)
                    {"x-ncr-cluster-slug" @cluster-slug}))
                :json-params
                {:query query
                 :variables variables}}))]

          (match response
            {:success true :body body}
            (let [{:keys [data errors]} body]
              (if (nil? errors)
                [:ok data]
                (do
                  (log/warn :what :gql-error :errors errors :data data)
                  [:error (-> errors first :extensions :code)])))

            {:success false :status status}
            (let [{:keys [error-text error-code]} response]
              (log/error :what :http-error :status status :code error-code :body (:body response))
              [:error (or error-text error-code)])

            _
            [:error :unexpected-server-response]))))))

(defn- var->defn [[n v]]
  (let [typ
        (cond
          (int? v) :Int
          (string? v) :String
          :else (throw (ex-info "Unknown value type" {:v v})))]
    {:variable/name n :variable/type typ}))

(defn- tx-local-substitute [args]
  (e/map-vals
    (fn [v]
      (if-let [[_ x] (and (keyword? v) (re-matches #"^\?(.*)$" (name v)))]
        (str "$?" x)
        v))
    args))

(defn !multi-operation
  [type queries & [vars]]
  (let
    [request-id (str "q" (gstr/getRandomString))
     vars' (sp/setval [sp/MAP-KEYS sp/NAME sp/FIRST] "" vars)
     query
     (gql/graphql-query
       (cond->
         {:queries
          (mapv
            (fn [[k v]]
              {:query/alias (keyword k)
               :query/data
               (match v
                 [q] [q]
                 [q a] [q (tx-local-substitute a)]
                 [q a f] [q (tx-local-substitute a) f])})
            queries)

          :operation
          {:operation/type type
           :operation/name (keyword request-id)}}

         (seq vars)
         (assoc :variables (mapv var->defn vars))))]
    (log/debug :what :graphql :query query)
    (go
      (u/error-m [result (<! (!request query vars' {"x-ncr-request-id" request-id}))]
        result))))

(def !multi-query
  (partial !multi-operation :query))

(defn !multi-mutation [mutations & [vars]]
  (!multi-operation :mutation
    (e/have! sequential? mutations) vars))

(defn !operation [type query & [vars]]
  (go
    (u/error-m
      [{:keys [default]}
       (<! (!multi-operation type {:default query} vars))]
      default)))

(def !query
  (partial !operation :query))

(def !mutation
  (partial !operation :mutation))

(defn parse-utc-date-time [in]
  (when in
    (t/in (t/zoned-date-time in) (t/zone))))

(defn parse-local-date-time [in]
  (when in
    (t/in (t/date-time in) (t/zone))))

#_(go
    (let
      [result
       (<!
         (!multi-query
           {:q [:properties_load {:reference "re1xSWsinXHquXiF8mG8qMya9rn3V"} []]}))]
      (log/debug :r result)))


#_(go
    (let
      [result
       (<!
         (!multi-query
           {:q
            [:fragment_load {:id "123"}
             [:id]
             #_[:id
                :name :labels :folder :writableHint :ownerWritableHint :promotedHint :revoked
                :readACL :writeACL :owner
                [:attachments [:id :fileName :length :mimeType :lastModified]]
                [:properties [:key :value]]]]}))]
      (log/debug :r result)))

